// extracted by mini-css-extract-plugin
export default {"loadingIndicator":"loadingIndicator_loadingIndicator__nE40T"};